// Where to send a user back to after they sign in (PRD 18 US-152).
//
// A magic link cannot carry the intended destination: the server mints
// `/auth/callback?token=…` and the round trip goes out through an inbox, so a
// `?next=` on `/signin` is gone by the time the session exists. The browser is
// the only thing present at both ends, so the destination is parked in
// `sessionStorage` — same tab, cleared when the tab closes, never sent anywhere.
//
// ONLY SAME-ORIGIN PATHS ARE ACCEPTED. `//evil.example` is a protocol-relative
// URL that a browser reads as a different host, so a bare `startsWith("/")`
// check is an open redirect. Anything else is dropped and the caller falls back
// to the org overview.

const KEY = "maisight_next";

export function isSafeNext(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//");
}

export function rememberNext(path: string): void {
  if (!isSafeNext(path)) return;
  try {
    window.sessionStorage.setItem(KEY, path);
  } catch {
    // Safari private mode throws. Losing the destination costs one redirect.
  }
}

/** Reads and clears — a destination is spent once, never replayed. */
export function takeNext(): string | null {
  try {
    const stored = window.sessionStorage.getItem(KEY);
    window.sessionStorage.removeItem(KEY);
    return stored && isSafeNext(stored) ? stored : null;
  } catch {
    return null;
  }
}
